import { MultiStepItemProps, AppToasterV2 } from "@ucl/library";
import { ApplicantSummary } from "./ApplicantSummary";
import { RequireAuth } from "@/lib/auth/RequireAuth";
import { useEffect } from "react";
import { useAuthenticatedApiClient } from "../../hooks/useAuthenticatedApiClient";
import FinancialApplicationApiClient from "../../api/financialApplicationApiClient";
import { useSetAtom } from "jotai";
import { hasVisitedConfirmDetailsAtom } from "@/atoms";
import { useNavigate } from "react-router-dom";
import "./ApplicantSummary.scss";

export interface ApplicantSummaryStepProps extends MultiStepItemProps {
  financialApplicationId: string;
}

export const ApplicantSummaryStep: React.FC<ApplicantSummaryStepProps> = (props) => {
  return (
    <RequireAuth clientType="consumer">
      <ApplicantSummaryStepInner {...props} />
    </RequireAuth>
  );
};

const ApplicantSummaryStepInner: React.FC<ApplicantSummaryStepProps> = (props) => {
  const financialApplicationApiClient = useAuthenticatedApiClient(FinancialApplicationApiClient);
  const setHasVisitedConfirmDetails = useSetAtom(hasVisitedConfirmDetailsAtom);
  const navigate = useNavigate();

    useEffect(() => {
    // Set the atom to true when this step is visited
    setHasVisitedConfirmDetails(true);
    
    const submitFunction = async () => {
      try {
        // Call the submit endpoint
        await financialApplicationApiClient.submitFinancialApplication(
          props.financialApplicationId
        );

        // Show success message
        AppToasterV2.showSuccessAppToaster("Application submitted successfully!");

        // Redirect to the application submitted page
        navigate("/application-submitted");
        
        // Return false to prevent the multi-step container from proceeding
        return false;
      } catch (error) {
        console.error("Failed to submit application:", error);
        AppToasterV2.showFailedActionToaster("Failed to submit application. Please try again.");
        return false;
      }
    };

    // Register the submit function with the multi-step container
    props.registerSubmit?.(submitFunction);
  }, [props.financialApplicationId, props.registerSubmit, financialApplicationApiClient, setHasVisitedConfirmDetails]);

  return (
    <section className="applicant-summary step-section">
      <div className="applicant-summary__header step-header">Review Your Application</div>
      <div className="applicant-summary__subtitle step-subtitle">
        You're almost done! Please review all the information below before submitting your application.
      </div>
      <div className="applicant-summary__content step-content">
        <ApplicantSummary financialApplicationId={props.financialApplicationId} />
      </div>
    </section>
  );
};
